import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Matches fixed header height (h-16 / lg:h-[4.25rem]) + gap */
const HEADER_OFFSET_PX = 88;

function scrollToId(elementId) {
  const el = document.getElementById(elementId);
  if (!el) return;
  const top =
    el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET_PX;
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
}

/**
 * React Router does not scroll to #anchors on navigation. This syncs the URL
 * hash on "/" with scroll position after Home renders.
 */
export default function ScrollToHash() {
  const { pathname, hash, key } = useLocation();

  useLayoutEffect(() => {
    if (pathname !== '/') return;

    const id = hash ? hash.replace(/^#/, '') : '';
    if (!id) return;

    const run = () => scrollToId(id);

    run();
    const t1 = window.setTimeout(run, 0);
    const t2 = window.setTimeout(run, 100);
    const t3 = window.setTimeout(run, 300);

    return () => {
      window.clearTimeout(t1);
      window.clearTimeout(t2);
      window.clearTimeout(t3);
    };
  }, [pathname, hash, key]);

  return null;
}
